export { default } from './TabContext';
export * from './TabContext';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TabContext/index.js
// module id = 116
// module chunks = 0